export enum SaasEscrowRoutesEnum {
  Overview = 'overview',
  Agreement = 'agreement',
  Deposits = 'deposits',
  Settings = 'settings',
  Members = 'members',
  Reports = 'reports',
}

export enum SaasEscrowSettingsRoutesEnum {
  Agreement = 'agreement',
  Beneficiary = 'beneficiary',
  Depositor = 'depositor',
  Technical = 'technical',
}
